import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import axiosClient from '../../../../../../../../lib/axios';
import LoadingFechamento from '../../LoadingFechamento';

export default function DialogExcluirFechamento({ open, id, onClose, handleExcluido }: DialogExcluirFechamentoProps) {

    const queryClient = useQueryClient();

    const { mutate: excluirFechamento, isLoading } = useMutation({
        mutationKey: 'excluir-fechamento',
        mutationFn: () => axiosClient.post(`/financeiro/conta-corrente-consumo/excluir-fechamento/${id}`),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao excluir fechamento", { variant: "error" })
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar("Fechamento excluído com sucesso", { variant: "success" })
            queryClient.invalidateQueries([`pesquisar-proximos-fechamentos`])
            handleExcluido()
        },
    });

    const handleExcluir = () => {
        excluirFechamento();
    }

    return (
        <Dialog maxWidth='xs' fullWidth open={open}>
            <DialogTitle>Excluir fechamento</DialogTitle>
            <DialogContent>
                {isLoading ? <LoadingFechamento id={id} label="Finalizando fechamento" /> : (
                    <DialogContentText>
                        Deseja realmente excluir o fechamento?
                    </DialogContentText>
                )}
            </DialogContent>
            {
                !isLoading && (
                    <DialogActions>
                        <Button variant="outlined" onClick={onClose}>Cancelar</Button>
                        <Button
                            color='error'
                            variant="contained"
                            onClick={handleExcluir}
                        >
                            Excluir
                        </Button>
                    </DialogActions>
                )
            }
        </Dialog>
    )
}

interface DialogExcluirFechamentoProps {
    open: boolean;
    id: number;
    onClose: () => void;
    handleExcluido: () => void;
}
